import React, { useEffect, useState } from 'react';
import RolesActions from '../RolesActions/RolesActions';
import TablePagination from '../TablePagination/TablePagination';
import {
  deleteRole,
  fetchRoles,
  sendUpdateRole,
  sendUpdateRoleStatus,
} from '../../api/rolesApi';
import ContextMenu from '../ContextMenu/ContextMenu';
import { createPortal } from 'react-dom';
import StaffTab from '../StaffTab/StaffTab';
import RolesTab from '../RolesTab/RolesTab';
import MassActions from '../MassActions/MassActions';
import { fetchStaff, removeUserFromWorkplace } from '../../api/staffApi.js';
import DepartmentTab from '../DepartmentTab/DepartmentTab.jsx';
import { deleteDepartment, fetchDepartments } from '../../api/departmentApi.js';
import { fetchClients } from '../../api/clientsApi.js';
import ClientsTab from '../ClientsTab/ClientsTab.jsx';
const WorkplaceManagement = ({ selectedItemId }) => {
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedItems, setSelectedItems] = useState([]); // Выбранные элементы
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [menuTarget, setMenuTarget] = useState({});
  const [massSelectedOption, setMassSelectedOption] = useState('');
  // const [isLoading, setIsLoading] = useState(false);
  const [activePopup, setActivePopup] = useState(null);
  const [selectedTab, setSelectedTab] = useState('department');
  const [typeAction, setTypeAction] = useState('');
  const [deleteError, setDeleteError] = useState();
  const [isLoadingMassActions, setIsLoadingMassActions] = useState(false);
  const [tabs, setTabs] = useState([
    { id: 'department', value: 'Структура организации', active: true },
    { id: 'employees', value: 'Сотрудники', active: false },
    { id: 'clients', value: 'Клиенты', active: false },
    { id: 'roles', value: 'Доступ', active: false },
  ]);

  const tabComponents = {
    employees: {
      component: StaffTab,
      fetchFunction: fetchStaff,
      deleteFunction: removeUserFromWorkplace,
    },
    roles: {
      component: RolesTab,
      fetchFunction: fetchRoles,
      deleteFunction: deleteRole,
      updateStatusFunction: sendUpdateRoleStatus,
      updateFunction: sendUpdateRole,
    },
    department: {
      component: DepartmentTab,
      fetchFunction: fetchDepartments,
      deleteFunction: deleteDepartment,
    },
    clients: {
      component: ClientsTab,
      fetchFunction: fetchClients,
      deleteFunction: removeUserFromWorkplace,
    }
  };

  const handleContextMenu = (e, item) => {
    e.preventDefault();
    handleTypeActionClear();
    setDeleteError('');
    setMenuTarget(item);
    setShowMenu(true);
    setMenuPosition({ top: e.clientY, left: e.clientX });
  };

  const handleCloseMenu = () => {
    setShowMenu(false);
  };
  const handleEdit = () => {
    handleSelectedPopup(selectedTab);
    setTypeAction('edit');
    setShowMenu(false);
  };

  const handleDuplicate = () => {
    console.log('Дублировать');

    setTypeAction('duplicate');
    handleSelectedPopup(selectedTab);
    setShowMenu(false);
  };

  const handleArchive = () => {
    console.log('В архив');
    setShowMenu(false);
    sendUpdateRole();
  };

  const handleTypeActionClear = () => {
    setTypeAction('');
    setMenuTarget({});
    setDeleteError('');
  };
  const parseJsonSafely = (data) => {
    try {
      return typeof data === 'string' ? JSON.parse(data) : data;
    } catch (error) {
      console.error('Ошибка парсинга JSON:', error);
      return null;
    }
  };

  const findItemRecursively = (list, targetId) => {
    for (const item of list) {
      if (item.id === targetId) {
        return item;
      }

      // Проверяем children (парсим, если строка)
      const children = parseJsonSafely(item.children);
      if (Array.isArray(children)) {
        const foundInChildren = findItemRecursively(children, targetId);
        if (foundInChildren) return foundInChildren;
      }

      // Проверяем workplaces (парсим, если строка)
      const workplaces = parseJsonSafely(item.workplaces);
      if (Array.isArray(workplaces)) {
        const foundInWorkplaces = findItemRecursively(workplaces, targetId);
        if (foundInWorkplaces) return foundInWorkplaces;
      }
    }
    return null;
  };

  // Проверка вложенности перед удалением
  const canDeleteItem = () => {
    const deletedItem = findItemRecursively(dataList, menuTarget.id);

    console.log(deletedItem, menuTarget.id); // Отладка

    if (!deletedItem) {
      setDeleteError('Элемент не найден');
      return false;
    }

    const children = parseJsonSafely(deletedItem.children);
    if (Array.isArray(children) && children.length > 0) {
      setDeleteError('Нельзя удалить элемент с вложенными отделами');
      return false;
    }

    const workplaces = parseJsonSafely(deletedItem.workplaces);
    if (Array.isArray(workplaces) && workplaces.length > 0) {
      setDeleteError('Нельзя удалить элемент с рабочими местами');
      return false;
    }

    return true;
  };

  const handleDelete = () => {
    console.log('Удалить');
    setShowMenu(false);

    if (!canDeleteItem()) return;

    const deleteFunction = tabComponents[selectedTab].deleteFunction;
    if (!deleteFunction) return;

    deleteFunction({ data: [menuTarget.id], organisation_id: selectedItemId })
      .then(() => {
        // Прямое удаление элемента из списка
        setDataList((prev) => {
          // Копируем список
          const updatedList = [...prev];

          // Функция для рекурсивного удаления элемента по id
          const deleteItemById = (list, targetId) => {
            for (let i = 0; i < list.length; i++) {
              const item = list[i];

              // Если нашли элемент
              if (item.id === targetId) {
                list.splice(i, 1); // Удаляем элемент
                return true; // Возвращаем true, чтобы прекратить поиск
              }

              // Если есть вложенные элементы, рекурсивно ищем
              if (item.children && Array.isArray(item.children)) {
                if (deleteItemById(item.children, targetId)) {
                  return true;
                }
              }

              if (item.workplaces && Array.isArray(item.workplaces)) {
                if (deleteItemById(item.workplaces, targetId)) {
                  return true;
                }
              }
            }
            return false;
          };

          // Используем рекурсивную функцию для удаления элемента по id
          deleteItemById(updatedList, menuTarget.id);

          return updatedList; // Возвращаем обновленный список
        });

        // Сбрасываем menuTargetId
        setMenuTarget(null);
      })
      .catch((err) => {
        console.error('Ошибка при удалении:', err);
      });
  };

  const options = [
    { value: 'restore', label: 'Восстановить' },
    { value: 'archive', label: 'Отправить в архив' },
    { value: 'delete', label: 'Удалить навсегда' },
  ];
  const handleSelectedPopup = (activePopup) => {
    setActivePopup(activePopup);

    if (!activePopup) {
      handleTypeActionClear();
    }
  };

  // Общие данные для пагинации
  const totalItems = dataList.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = dataList.slice(startIndex, startIndex + itemsPerPage);

  // Обработчик выбора элементов
  const handleSelectItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const updateTabData = (tabId) => {
    if (!selectedItemId) return;
    const fetchFunction = tabComponents[tabId]?.fetchFunction;
    if (!fetchFunction) return;
    fetchFunction(selectedItemId)
      .then((res) => {
        const updatedList = res.data.map((item, index) => ({
          ...item,
          number: index + 1,
        }));

        setDataList(updatedList);
      })
      .catch((error) => {
        console.error(`Ошибка при загрузке данных для ${tabId}:`, error);
      });
  };

  const ActiveTabComponent = tabComponents[selectedTab].component;

  const handleTabSelected = (e) => {
    const clickedId = e.currentTarget.dataset.id;
    setTabs((prev) =>
      prev.map((item) => ({
        ...item,
        active: item.id === clickedId,
      }))
    );

    setSelectedTab(clickedId);
    setSelectedItems([]);
  };
  const handleApplyMassActions = () => {
    setIsLoadingMassActions(true);
    setShowMenu(false);
    if (!selectedItems.length) {
      setIsLoadingMassActions(false);
      return console.warn('Нет выбранных элементов для выполнения действия.');
    }

    const tabComponent = tabComponents[selectedTab];

    if (massSelectedOption === 'delete') {
      if (!tabComponent?.deleteFunction) {
        setIsLoadingMassActions(false);
        return;
      }

      tabComponent
        .deleteFunction({ data: selectedItems, organisation_id: selectedItemId })
        .then(() => {
          setDataList((prev) =>
            prev.filter((item) => item.id !== menuTarget.id)
          );
          updateTabData(selectedTab);
          setMenuTarget(null);
          setMassSelectedOption([]);
          setSelectedItems([]);
        })
        .catch((err) => console.error('Ошибка при удалении:', err))
        .finally(() => {
          setIsLoadingMassActions(false);
          setMassSelectedOption([]);
        });
    } else if (['archive', 'restore'].includes(massSelectedOption)) {
      if (!tabComponent?.updateStatusFunction) {
        setIsLoadingMassActions(false);
        setMassSelectedOption([]);
        return;
      }

      const statusId = massSelectedOption === 'archive' ? 2 : 1;

      tabComponent
        .updateStatusFunction({
          data: selectedItems.map((id) => ({ id, status_id: statusId })),
          organisation_id: selectedItemId,
        })
        .then(() => {
          updateTabData(selectedTab);
          setMassSelectedOption([]);
          setSelectedItems([]);
        })
        .catch((err) => console.error('Ошибка при обновлении статуса:', err))
        .finally(() => {
          setIsLoadingMassActions(false);
          setMassSelectedOption([]);
        });
    } else {
      console.warn(`Неизвестное массовое действие: ${massSelectedOption}`);
      setIsLoadingMassActions(false);
      setMassSelectedOption([]);
    }
  };

  useEffect(() => {
    updateTabData(selectedTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab, selectedItemId]);

  return (
    <div className='roles'>
      <div className='roles__actions'>
        <RolesActions
          updateTabData={updateTabData}
          handleSelectedPopup={handleSelectedPopup}
          tabs={tabs}
          handleTabSelected={handleTabSelected}
          selectedTab={selectedTab}
        />
      </div>

      <ActiveTabComponent
        handleContextMenu={handleContextMenu}
        dataList={paginatedData} // Передаём нужные данные в таблицу
        onSelectItem={handleSelectItem}
        selectedItems={selectedItems}
        selectedItemId={selectedItemId}
        activePopup={activePopup}
        handleSelectedPopup={handleSelectedPopup}
        updateTabData={updateTabData}
        selectedTab={selectedTab}
        menuTarget={menuTarget}
        typeAction={typeAction}
        handleTypeActionClear={handleTypeActionClear}
        deleteError={deleteError}
      />
      <MassActions
        options={options}
        placeholder='Массовые действия'
        value={massSelectedOption}
        onSelectChange={(selected) => setMassSelectedOption(selected.value)}
        onApply={handleApplyMassActions}
        selectClassName=''
        buttonClassName=''
        isLoadingMassActions={isLoadingMassActions}
      />
      <TablePagination
        totalItems={totalItems}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        itemsPerPageOptions={[10, 20, 50, 100]}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setItemsPerPage={setItemsPerPage}
        selectedItemsCount={selectedItems.length}
      />
      {showMenu &&
        createPortal(
          <ContextMenu
            top={menuPosition.top}
            left={menuPosition.left}
            onEdit={handleEdit}
            onDuplicate={handleDuplicate}
            onArchive={handleArchive}
            onDelete={handleDelete}
            onClose={handleCloseMenu}
          />,
          document.body
        )}
    </div>
  );
};

export default WorkplaceManagement;
